import * as CONSTANTS from './constants';

export const getInitialState = () => {
  return {
    faqData: {},
    metaData: {},
    goSafeBanner: {},
    offers: {},
    rtcHomeBanner: { 'isLoading': false, 'isError': false, 'data': [] },
    busHomeCarousel: { 'isLoading': false, 'isError': false, 'data': [] },
    userLoyaltyInfo: {}
  };
}

export default function Home(state = getInitialState(), action) {
  const { type, actionData } = action;

  switch (type) {
    case CONSTANTS.UPDATE_META_DATA:
      let metaData = Object.assign({}, state.metaData);
      metaData['isLoading'] = actionData.isLoading;
      metaData['isError'] = actionData.isError;
      metaData['data'] = actionData.data;

      return Object.assign({}, state, {
        ...state,
        metaData: metaData,

      })
    case CONSTANTS.UPDATE_FAQ_DATA:
      let faqData = Object.assign({}, state.faqData);
      faqData['isLoading'] = actionData.isLoading;
      faqData['isError'] = actionData.isError;
      faqData['data'] = actionData.data;

      return Object.assign({}, state, {
        ...state,
        faqData: faqData
      })

    case CONSTANTS.UPDATE_GOSAFE_BANNER:
      let goSafeBanner = Object.assign({}, state.goSafeBanner);
      goSafeBanner['isLoading'] = actionData.isLoading;
      goSafeBanner['isError'] = actionData.isError;
      goSafeBanner['data'] = actionData.data;

      return Object.assign({}, state, {
        ...state,
        goSafeBanner: goSafeBanner
      })

    case CONSTANTS.UPDATE_OFFERS_DATA:
      let offers = Object.assign({}, state.offers);
      offers['isLoading'] = actionData.isLoading;
      offers['isError'] = actionData.isError;
      offers['data'] = actionData.data;

      return Object.assign({}, state, {
        ...state,
        offers: offers
      })

    case CONSTANTS.UPDATE_RTC_HOME_BANNER:
      let rtcHomeBanner = Object.assign({}, state.rtcHomeBanner);
      rtcHomeBanner['isLoading'] = actionData.isLoading;
      rtcHomeBanner['isError'] = actionData.isError;
      rtcHomeBanner['data'] = actionData.data;

      return Object.assign({}, state, {
        ...state,
        rtcHomeBanner: rtcHomeBanner
      })

    case CONSTANTS.UPDATE_BUS_HOME_CAROUSEL:
      let busHomeCarousel = Object.assign({}, state.busHomeCarousel);
      busHomeCarousel['isLoading'] = actionData.isLoading;
      busHomeCarousel['isError'] = actionData.isError;
      busHomeCarousel['data'] = actionData.data;

      return Object.assign({}, state, {
        ...state,
        busHomeCarousel: busHomeCarousel
      })

    case CONSTANTS.SAVE_LOYALTY_DATA:
      return Object.assign({}, state, {
        ...state,
        userLoyaltyInfo: actionData
      })
    default:
      return state;
  }
}


